import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { useAuthStore } from './auth-store';

interface CelebrationStore {
  /** Tasks the user completed in this page load, for the My Tasks banner. */
  completedCount: number;
  recordCompletion: () => void;

  /** The recording-started card, queued by a page that is gone by the time it shows. */
  recordingStarted: { processName: string } | null;
  queueRecordingStarted: (processName: string) => void;
  clearRecordingStarted: () => void;
}

const initialState = { completedCount: 0, recordingStarted: null };

export const useCelebrationStore = create<CelebrationStore>()(
  devtools(
    (set) => ({
      ...initialState,
      recordCompletion: () => set((state) => ({ completedCount: state.completedCount + 1 })),
      queueRecordingStarted: (processName) => set({ recordingStarted: { processName } }),
      clearRecordingStarted: () => set({ recordingStarted: null })
    }),
    { name: 'celebration-store' }
  )
);

// Keyed on the workspace, not the token: `refreshSession` calls `setAuth`
// mid-session, and `clearAuth` (sign-out) nulls the tenant too.
useAuthStore.subscribe((auth, previousAuth) => {
  if (auth.tenant?.slug !== previousAuth.tenant?.slug) {
    useCelebrationStore.setState(initialState);
  }
});

export const useCompletedCount = () => useCelebrationStore((state) => state.completedCount);
